var _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRocket(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11 15.11l3.78 3.78c.068.068.166.091.255.06.938-.333 6.222-2.316 9.855-5.95 3.673-3.673 2.287-9.033 2.036-9.884a.217.217 0 00-.152-.152C20.033 2.714 14.674 1.327 11 5c-3.634 3.634-5.617 8.917-5.95 9.855a.243.243 0 00.06.254z",
    stroke: "#121318",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.5v3l-4 2v-3M7.5 9h-3l-2 4h3",
    stroke: "#121318",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 8,
    r: 2,
    stroke: "#121318",
    strokeWidth: 2
  })));
}

export default SvgRocket;